import { createModule } from "direct-vuex";
import { moduleActionContext } from "..";
import actions from "./actions";
import { UserState } from "../user/types";
import { UserResource } from "./types";

const user = createModule({
  namespaced: true,
  state: (): UserState => {
    return {
      usersList: [],
      users: {},
      selected: undefined
    };
  },
  getters: {
    users(state) {
      return state.usersList.map(id => {
        return state.users[id];
      });
    }
  },
  mutations: {
    SET_USERS(state, users: UserResource[]) {
      state.users = {};
      state.usersList = [];
      users.forEach(user => {
        state.users[user.id] = user;
        state.usersList.push(user.id);
      });
    },
    SET_SELECTED(state, user: UserResource) {
      state.selected = { ...user };
    },
    CLEAR_SELECTED(state) {
      state.selected = undefined;
    },
    REMOVE_USER(state, id: string) {
      let idx = state.usersList.findIndex(b => {
        return b == id;
      });
      state.usersList.splice(idx, 1);
      delete state.users[id];
    }
  },
  actions: actions
});

export default user;
export const userActionContext = (context: any) =>
  moduleActionContext(context, user);
